import React, { useState, useEffect, useRef } from 'react';
import api from '../api';

// ─── Keyframe piscar (mensagem não lida) ─────────────────────────────────────
const _styleNovaMensagem = document.getElementById('__sobraa-piscar');
if (!_styleNovaMensagem) {
  const s = document.createElement('style');
  s.id = '__sobraa-piscar';
  s.textContent = `
    @keyframes piscar {
      0%,100% { background-color: #fffbf0; }
      50%      { background-color: #fef3c7; }
    }
  `;
  document.head.appendChild(s);
}

// ─── Paleta Sobraa ────────────────────────────────────────────────────────────
const C = {
  navy: '#1A2233', orange: '#D85A30', orangeHover: '#B84A24',
  bg: '#f5f7fa', surface: '#ffffff', border: '#d4dde8',
  muted: '#6b7a8d', text: '#1A2233', success: '#27ae60', error: '#e74c3c',
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
function formatHora(dt) {
  if (!dt) return '';
  return new Date(dt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}
function formatTelefone(tel) {
  if (!tel) return '';
  const d = String(tel).replace(/\D/g, '');
  if (d.length === 13) return `+${d.slice(0,2)} (${d.slice(2,4)}) ${d.slice(4,9)}-${d.slice(9)}`;
  if (d.length === 11) return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
  return tel;
}
function iniciais(nome) {
  if (!nome) return '?';
  return nome.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase();
}

// ─── Componente Avatar ────────────────────────────────────────────────────────
function Avatar({ nome, size = 36 }) {
  const colors = ['#7c3aed','#0369a1','#065f46','#92400e','#be185d','#1d4ed8'];
  const idx = (nome || '').charCodeAt(0) % colors.length;
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', background: colors[idx], color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.35, fontWeight: 700, flexShrink: 0, userSelect: 'none',
    }}>
      {iniciais(nome)}
    </div>
  );
}

// ─── Autocomplete de Empresa ──────────────────────────────────────────────────
function EmpresaSelect({ value, onChange, clientes, style }) {
  return (
    <select
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      style={style}
    >
      <option value="">— Selecionar empresa —</option>
      {clientes.map((c, i) => (
        <option key={c.id || i} value={c.nome}>{c.nome}</option>
      ))}
    </select>
  );
}

// ─── Componente principal ─────────────────────────────────────────────────────
export default function Chat({ toast, usuario }) {
  const [conversas, setConversas] = useState([]);
  const [aba, setAba] = useState('fila');
  const [busca, setBusca] = useState('');
  const [filas, setFilas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  const [conversaSel, setConversaSel] = useState(null);
  const [mensagens, setMensagens] = useState([]);
  const [texto, setTexto] = useState('');
  const [enviando, setEnviando] = useState(false);

  const [modalIniciar, setModalIniciar] = useState(false);
  const [modalTransferir, setModalTransferir] = useState(false);
  const [modalTicket, setModalTicket] = useState(false);
  const [modalContatos, setModalContatos] = useState(false);

  const [contatos, setContatos] = useState([]);
  const [buscaContato, setBuscaContato] = useState('');
  const [modalNovoContato, setModalNovoContato] = useState(false);
  const [contatoForm, setContatoForm] = useState({ telefone: '', nome: '', email: '', empresa: '', observacao: '' });
  const [editandoContato, setEditandoContato] = useState(null);

  const [iniciarForm, setIniciarForm] = useState({ telefone: '', nome: '', mensagem: '', fila: '' });

  const [transferirTipo, setTransferirTipo] = useState('fila');
  const [transferirFila, setTransferirFila] = useState('');
  const [transferirTecnico, setTransferirTecnico] = useState('');

  const [ticketForm, setTicketForm] = useState({
    titulo: '', descricao: '', fila: '',
    comentario: '', tempo_hhmm: '00:00',
    tipo_atendimento: 'externo',
    tipo_id: '', categoria_id: '', subcategoria_id: '', mesa_id: '',
    solicitante: '', telefone_cliente: '', email_cliente: '', operador_id: '',
  });

  const [mensagemRespondendo, setMensagemRespondendo] = useState(null);

  const [gravando, setGravando] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioURL, setAudioURL] = useState(null);
  const [tempoGravacao, setTempoGravacao] = useState(0);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const timerGravacaoRef = useRef(null);

  const [tiposTicket, setTiposTicket] = useState([]);
  const [categoriasTicket, setCategoriasTicket] = useState([]);
  const [mesasTicket, setMesasTicket] = useState([]);
  const [operadoresMesa, setOperadoresMesa] = useState([]);

  // ─── Busca de cliente no modal de ticket ─────────────────────────────────────
  const [ticketClienteId, setTicketClienteId] = useState('');
  const [ticketClienteBusca, setTicketClienteBusca] = useState('');
  const [ticketClienteSugestoes, setTicketClienteSugestoes] = useState([]);
  const [ticketClienteAberto, setTicketClienteAberto] = useState(false);

  const messagesEndRef = useRef(null);
  const conversaSelRef = useRef(null);
  const pollingRef = useRef(null);
  const textareaRef = useRef(null);
  const versaoRef = useRef(0);
  const mensagensContainerRef = useRef(null); // ref no container de mensagens
  const usuarioNoFimRef = useRef(true);        // true = usuário está no fim do scroll
  const ultimaMsgIdRef = useRef(null);         // id da última mensagem já rolada — evita scroll repetido sem mensagem nova

  // ─── Lista de clientes para autocomplete de Empresa ─────────────────────────
  const [clientesOrcamento, setClientesOrcamento] = useState([]);
  const carregarClientesOrcamento = async () => {
    if (clientesOrcamento.length > 0) return clientesOrcamento; // já carregou
    try {
      const r = await api.get('/orcamentos/clientes/todos');
      const lista = Array.isArray(r.data) ? r.data : [];
      setClientesOrcamento(lista);
      return lista;
    } catch { return []; }
  };

  // ─── Alerta sonoro — preferência global (lida/escrita pelo App.js) ───────────
  const [somAtivo, setSomAtivo] = useState(() => {
    try { return localStorage.getItem('som_alertas_ativo') !== 'false'; }
    catch { return true; }
  });
  const conversasAnterioresRef = useRef(null);

  // ─── Mensagens não lidas — indicador visual na lista de conversas ────────────
  // O App.js mantém window.__chatNovasMensagens = { [id]: true }
  // A cada render do polling, sincronizamos para um estado React para re-render
  const [novasMensagensMap, setNovasMensagensMap] = useState({});

  useEffect(() => {
    // Sincroniza o mapa de mensagens novas do window para o estado local a cada 1s
    const sync = setInterval(() => {
      const mapa = window.__chatNovasMensagens || {};
      setNovasMensagensMap(prev => {
        // Só re-renderiza se houver diferença
        const keysAntes  = Object.keys(prev).sort().join(',');
        const keysDepois = Object.keys(mapa).sort().join(',');
        if (keysAntes === keysDepois) return prev;
        return { ...mapa };
      });
    }, 1000);
    return () => clearInterval(sync);
  }, []);

  // ─── Modal salvar contato antes de encerrar ──────────────────────────────────
  const [modalSalvarContato, setModalSalvarContato] = useState(false); // 'encerrar' | 'ticket' | false
  const [salvarContatoForm, setSalvarContatoForm] = useState({ nome: '', telefone: '', email: '', empresa: '', observacao: '' });
  const [salvarContatoOpcao, setSalvarContatoOpcao] = useState(true);
  const [contatoJaExiste, setContatoJaExiste] = useState(null); // null | objeto do contato existente

  // ─── Carga inicial ──────────────────────────────────────────────────────────
  useEffect(() => {
    carregarFilas();
    carregarUsuarios();
    carregarConversas();
    pollingRef.current = setInterval(() => {
      carregarConversas();
      if (conversaSelRef.current) carregarMensagens(conversaSelRef.current.id, false);
    }, 4000);
    return () => {
      clearInterval(pollingRef.current);
      if (timerGravacaoRef.current) clearInterval(timerGravacaoRef.current);
      // Limpa estado global ao desmontar o Chat
      window.__chatConversaAtiva = null;
    };
  }, []);

  useEffect(() => {
    // Só rola automaticamente se houve mensagem nova de verdade (evita rolar a cada
    // poll de 4s quando nada mudou — o array vem novo do backend mesmo sem novidade)
    // e se o usuário já estava no fim da conversa.
    if (mensagens.length === 0) return;
    const idAtual = mensagens[mensagens.length - 1]?.id;
    const houveNovaMensagem = idAtual !== ultimaMsgIdRef.current;
    ultimaMsgIdRef.current = idAtual;

    if (houveNovaMensagem && usuarioNoFimRef.current) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [mensagens]);

  // Atualiza operadores quando muda a mesa
  useEffect(() => {
    if (!ticketForm.mesa_id) { setOperadoresMesa([]); return; }
    const mesa = mesasTicket.find(m => String(m.id) === String(ticketForm.mesa_id));
    if (mesa?.membros_ids?.length > 0) {
      setOperadoresMesa(usuarios.filter(u => mesa.membros_ids.includes(u.id)));
    } else {
      setOperadoresMesa(usuarios);
    }
  }, [ticketForm.mesa_id, mesasTicket, usuarios]);

  // ─── Carregamentos ──────────────────────────────────────────────────────────
  const carregarFilas = async () => {
    try { const r = await api.get('/whatsapp/filas'); setFilas(r.data); } catch {}
  };

  const carregarUsuarios = async () => {
    try {
      const r = await api.get('/usuarios');
      const raw = Array.isArray(r.data) ? r.data
        : Array.isArray(r.data?.usuarios) ? r.data.usuarios
        : Array.isArray(r.data?.data) ? r.data.data
        : [];
      const lista = raw.filter(u =>
        u.ativo === true || u.ativo === 1 || u.status === 'ativo' || u.ativo === undefined
      );
      setUsuarios(lista);
    } catch (e) {
      console.error('[Chat] erro ao carregar usuários:', e.message);
    }
  };

  // ─── carregarConversas — apenas atualiza UI (som gerenciado pelo App.js) ─────
  const carregarConversas = async () => {
    try {
      const r = await api.get('/whatsapp/conversas');
      conversasAnterioresRef.current = r.data;
      setConversas(r.data);
    } catch {}
  };

  const carregarMensagens = async (id, scroll = true) => {
    const versaoAtual = versaoRef.current;
    try {
      const r = await api.get(`/whatsapp/conversas/${id}/mensagens`);
      if (versaoRef.current !== versaoAtual) return;
      if (conversaSelRef.current?.id !== id) return;
      setMensagens(r.data.mensagens || []);
      if (r.data.conversa) {
        setConversaSel(prev => prev?.id === id ? { ...prev, ...r.data.conversa } : prev);
        conversaSelRef.current = { ...conversaSelRef.current, ...r.data.conversa };
      }
      if (scroll) setTimeout(() => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    } catch {}
  };

  const carregarContatos = async () => {
    try { const r = await api.get('/whatsapp/contatos'); setContatos(r.data); } catch {}
  };

  const carregarDadosTicket = async () => {
    try {
      const [tipos, cats, mesas] = await Promise.all([
        api.get('/tickets/tipos').catch(() => ({ data: [] })),
        api.get('/tickets/categorias').catch(() => ({ data: [] })),
        api.get('/tickets/mesas').catch(() => ({ data: [] })),
      ]);
      setTiposTicket(tipos.data || []);
      setCategoriasTicket(cats.data || []);
      setMesasTicket(mesas.data || []);
    } catch {}
  };

  // ─── Selecionar conversa ─────────────────────────────────────────────────────
  const selecionarConversa = async (conv) => {
    clearInterval(pollingRef.current);
    versaoRef.current += 1;
    const minhaVersao = versaoRef.current;

    setMensagens([]);
    ultimaMsgIdRef.current = null; // nova conversa — reseta o rastreador de última mensagem
    setAudioBlob(null);
    setAudioURL(null);
    setTexto('');
    setMensagemRespondendo(null);
    setConversaSel(conv);
    conversaSelRef.current = conv;
    usuarioNoFimRef.current = true; // ao abrir conversa, sempre rola para o fim
    // Informa o App.js qual conversa está aberta → suprime som dessa conversa
    window.__chatConversaAtiva = conv?.id || null;
    // Marca como lida no mapa de novas mensagens
    if (conv?.id && window.__chatNovasMensagens) {
      delete window.__chatNovasMensagens[conv.id];
      setNovasMensagensMap(prev => { const n = { ...prev }; delete n[conv.id]; return n; });
    }
    if (isMobile) setViewMobile('chat');

    try {
      const r = await api.get(`/whatsapp/conversas/${conv.id}/mensagens`);
      if (versaoRef.current !== minhaVersao) return;
      setMensagens(r.data.mensagens || []);
      if (r.data.conversa) {
        setConversaSel(prev => prev?.id === conv.id ? { ...prev, ...r.data.conversa } : prev);
        conversaSelRef.current = { ...conversaSelRef.current, ...r.data.conversa };
      }
      setTimeout(() => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    } catch {}

    pollingRef.current = setInterval(() => {
      carregarConversas();
      if (conversaSelRef.current) carregarMensagens(conversaSelRef.current.id, false);
    }, 4000);
  };
  selecionarConversa._sessao = 0;

  // ─── Assumir conversa ────────────────────────────────────────────────────────
  const assumirConversa = async (conv) => {
    try {
      await api.patch(`/whatsapp/conversas/${conv.id}`, {
        atendente_id: usuario?.id,
        atendente_nome: usuario?.nome,
        status: 'em_atendimento',
      });
      await carregarConversas();
      await selecionarConversa({ ...conv, status: 'em_atendimento', atendente_id: usuario?.id });
      setAba('meus');
      toast('Conversa assumida!', 'success');
    } catch { toast('Erro ao assumir conversa', 'error'); }
  };

  // ─── Enviar mensagem de texto ───────────────────────────────────────────────
  const enviarMensagem = async () => {
    if (!texto.trim() || !conversaSel || enviando) return;
    setEnviando(true);
    try {
      await api.post(`/whatsapp/conversas/${conversaSel.id}/mensagens`, {
        conteudo: texto.trim(),
        mensagem_citada: mensagemRespondendo
          ? `${mensagemRespondendo.usuario_nome || mensagemRespondendo.origem || 'Mensagem'}: ${mensagemRespondendo.conteudo || ''}`.substring(0, 200)
          : null,
      });
      setTexto('');
      setMensagemRespondendo(null);
      await carregarMensagens(conversaSel.id);
      await carregarConversas();
    } catch { toast('Erro ao enviar mensagem', 'error'); }
    setEnviando(false);
  };

  // ─── Encerrar conversa ──────────────────────────────────────────────────────
  const encerrarConversa = async () => {
    if (!conversaSel) return;
    if (!window.confirm('Encerrar este atendimento?')) return;
    // Verificar se o contato já existe na agenda
    try {
      const tel = String(conversaSel.telefone || '').replace(/\D/g, '');
      const r = await api.get(`/whatsapp/contatos?busca=${tel}`);
      const existente = (r.data || []).find(c => String(c.telefone).replace(/\D/g,'') === tel);
      if (existente) {
        // Contato já cadastrado — encerrar direto sem modal
        await _executarEncerrar(false);
        return;
      }
    } catch {}
    // Contato não encontrado — abrir modal para salvar
    setSalvarContatoForm({
      nome: conversaSel.nome_contato || '',
      telefone: conversaSel.telefone || '',
      email: '',
      empresa: '',
      observacao: '',
    });
    setSalvarContatoOpcao(true);
    setContatoJaExiste(null);
    carregarClientesOrcamento();
    setModalSalvarContato('encerrar');
  };

  const _executarEncerrar = async (salvar) => {
    setModalSalvarContato(false);
    try {
      if (salvar && salvarContatoForm.telefone && salvarContatoForm.nome) {
        await api.post('/whatsapp/contatos', salvarContatoForm).catch(() => {});
      }
      await api.patch(`/whatsapp/conversas/${conversaSel.id}`, { status: 'encerrado' });
      setConversaSel(null);
      conversaSelRef.current = null;
      setMensagens([]);
      await carregarConversas();
      toast('Atendimento encerrado', 'success');
    } catch { toast('Erro ao encerrar', 'error'); }
  };

  // ─── Transferir ─────────────────────────────────────────────────────────────
  const confirmarTransferir = async () => {
    if (!conversaSel) return;
    try {
      let payload;
      if (transferirTipo === 'fila') {
        if (!transferirFila) { toast('Selecione uma fila', 'error'); return; }
        const filaNome = filas.find(f => f.chave === transferirFila)?.nome || transferirFila;
        payload = { fila: transferirFila, fila_nome: filaNome, atendente_id: null, atendente_nome: null };
      } else {
        if (!transferirTecnico) { toast('Selecione um técnico', 'error'); return; }
        const tec = usuarios.find(u => String(u.id) === String(transferirTecnico));
        if (!tec) { toast('Técnico não encontrado', 'error'); return; }
        payload = { atendente_id: tec.id, atendente_nome: tec.nome, fila: conversaSel.fila };
      }
      await api.patch(`/whatsapp/conversas/${conversaSel.id}/transferir`, payload);
      setModalTransferir(false);
      setConversaSel(null);
      conversaSelRef.current = null;
      setMensagens([]);
      await carregarConversas();
      toast('Transferido com sucesso!', 'success');
    } catch { toast('Erro ao transferir', 'error'); }
  };

  // ─── Abrir modal de ticket ───────────────────────────────────────────────────
  const abrirModalTicket = async () => {
    if (!conversaSel) return;
    await carregarDadosTicket();

    let inicioChatReal = new Date();
    try {
      const r = await api.get(`/whatsapp/conversas/${conversaSel.id}/mensagens`);
      const convFresca = r.data.conversa;
      if (convFresca?.criado_em) inicioChatReal = new Date(convFresca.criado_em);
      setMensagens(r.data.mensagens || []);
    } catch {}

    const agora = new Date();
    const diffSeg = Math.max(0, Math.floor((agora - inicioChatReal) / 1000));
    const hh = String(Math.floor(diffSeg / 3600)).padStart(2, '0');
    const mm = String(Math.floor((diffSeg % 3600) / 60)).padStart(2, '0');

    setTicketForm({
      titulo: '',
      descricao: '',
      fila: conversaSel.fila || (filas[0]?.chave) || '',
      comentario: '',
      tempo_hhmm: `${hh}:${mm}`,
      tipo_atendimento: 'externo',
      tipo_id: '', categoria_id: '', subcategoria_id: '', mesa_id: '',
      solicitante: conversaSel.nome_contato || '',
      telefone_cliente: conversaSel.telefone || '',
      email_cliente: '',
      operador_id: '',
    });
    // Resetar seleção de cliente
    setTicketClienteId('');
    setTicketClienteBusca('');
    setTicketClienteSugestoes([]);
    setTicketClienteAberto(false);
    // Garantir que a lista de clientes esteja carregada
    const clientes = await carregarClientesOrcamento();

    // Busca o contato na agenda pelo telefone do chat
    // Se tiver empresa vinculada, pré-seleciona o cliente correspondente
    try {
      const tel = String(conversaSel.telefone || '').replace(/\D/g, '');
      if (tel) {
        const r = await api.get(`/whatsapp/contatos?busca=${tel}`);
        const contato = (r.data || []).find(c =>
          String(c.telefone).replace(/\D/g, '') === tel ||
          String(c.telefone).replace(/\D/g, '') === (tel.startsWith('55') ? tel.slice(2) : '55' + tel)
        );
        if (contato?.empresa) {
          // Tenta achar o cliente em clientes_orcamento pelo nome da empresa
          const lista = clientes || [];
          const match = lista.find(c =>
            (c.nome || '').toLowerCase().trim() === contato.empresa.toLowerCase().trim() ||
            (c.cliente_apelido || '').toLowerCase().trim() === contato.empresa.toLowerCase().trim()
          );
          if (match) {
            setTicketClienteId(String(match.id));
            setTicketClienteBusca(match.cliente_apelido ? `${match.cliente_apelido} (${match.nome})` : match.nome);
          }
          // Email do contato na agenda
          if (contato.email) {
            setTicketForm(f => ({ ...f, email_cliente: contato.email }));
          }
        }
      }
    } catch (e) {
      console.warn('[Ticket] Erro ao buscar contato da agenda:', e.message);
    }

    setModalTicket(true);
  };

  // ─── Criar ticket + encerrar ────────────────────────────────────────────────
  const confirmarCriarTicket = async () => {
    if (!conversaSel) return;
    const faltando = [];
    if (!ticketForm.titulo.trim())          faltando.push('Título');
    if (!ticketForm.descricao.trim())       faltando.push('Descrição');
    if (!ticketClienteId)                   faltando.push('Cliente');
    if (!ticketForm.solicitante.trim())     faltando.push('Solicitante');
    if (!ticketForm.telefone_cliente.trim()) faltando.push('Telefone');
    if (!ticketForm.tipo_id)                faltando.push('Tipo de Ticket');
    if (!ticketForm.categoria_id)           faltando.push('Categoria');
    if (!ticketForm.mesa_id)                faltando.push('Mesa de Trabalho');
    if (faltando.length) {
      toast(`Campos obrigatórios não preenchidos: ${faltando.join(', ')}.`, 'error');
      return;
    }
    // Verificar se o contato já existe
    try {
      const tel = String(ticketForm.telefone_cliente || conversaSel.telefone || '').replace(/\D/g, '');
      if (tel) {
        const r = await api.get(`/whatsapp/contatos?busca=${tel}`);
        const existente = (r.data || []).find(c => String(c.telefone).replace(/\D/g,'') === tel);
        if (existente) {
          // Contato já existe — criar ticket direto sem modal
          await _executarCriarTicket(false);
          return;
        }
      }
    } catch {}
    // Contato não existe — abrir modal
    setSalvarContatoForm({
      nome: ticketForm.solicitante || conversaSel.nome_contato || '',
      telefone: ticketForm.telefone_cliente || conversaSel.telefone || '',
      email: ticketForm.email_cliente || '',
      empresa: '',
      observacao: '',
    });
    setSalvarContatoOpcao(true);
    setContatoJaExiste(null);
    carregarClientesOrcamento();
    setModalSalvarContato('ticket');
  };

  const _executarCriarTicket = async (salvar) => {
    setModalSalvarContato(false);
    try {
      if (salvar && salvarContatoForm.telefone && salvarContatoForm.nome) {
        await api.post('/whatsapp/contatos', salvarContatoForm).catch(() => {});
      }
      const [hh, mm] = (ticketForm.tempo_hhmm || '00:00').split(':').map(Number);
      const tempoSeg = ((hh || 0) * 3600) + ((mm || 0) * 60);
      const payload = {
        titulo: ticketForm.titulo,
        descricao: ticketForm.descricao,
        fila: ticketForm.fila,
        comentario_finalizacao: ticketForm.comentario,
        tipo_atendimento: ticketForm.tipo_atendimento,
        tempo_total_segundos: tempoSeg,
        tipo_id: ticketForm.tipo_id || null,
        categoria_id: ticketForm.categoria_id || null,
        subcategoria_id: ticketForm.subcategoria_id || null,
        mesa_id: ticketForm.mesa_id || null,
        atendente_id: ticketForm.operador_id || null,
        cliente_id: ticketClienteId || null,
        cliente_nome: ticketForm.solicitante,
        cliente_telefone: ticketForm.telefone_cliente,
        cliente_email: ticketForm.email_cliente,
      };
      const r = await api.post(`/whatsapp/conversas/${conversaSel.id}/criar-ticket`, payload);
      setModalTicket(false);
      setConversaSel(null);
      conversaSelRef.current = null;
      setMensagens([]);
      await carregarConversas();
      toast(`Ticket #${r.data.ticket.id} criado e atendimento encerrado!`, 'success');
    } catch (err) {
      const msg = err?.response?.data?.erro || err?.data?.erro || err?.erro || 'Erro ao criar ticket';
      toast(msg, 'error');
    }
  };

  // ─── Iniciar conversa ───────────────────────────────────────────────────────
  const confirmarIniciarConversa = async () => {
    const { telefone, mensagem, nome, fila } = iniciarForm;
    if (!telefone.trim() || !mensagem.trim()) { toast('Telefone e mensagem são obrigatórios', 'error'); return; }
    try {
      const r = await api.post('/whatsapp/conversas/iniciar', {
        telefone: telefone.replace(/\D/g, ''),
        nome: nome || telefone,
        mensagem,
        fila: fila || (filas[0]?.chave),
      });
      setModalIniciar(false);
      setIniciarForm({ telefone: '', nome: '', mensagem: '', fila: '' });
      await carregarConversas();
      selecionarConversa(r.data);
      setAba('meus');
      toast('Conversa iniciada!', 'success');
    } catch (e) { toast(e.response?.data?.erro || 'Erro ao iniciar conversa', 'error'); }
  };

  // ─── Contatos ────────────────────────────────────────────────────────────────
  const salvarContato = async () => {
    if (!contatoForm.telefone || !contatoForm.nome) { toast('Telefone e nome são obrigatórios', 'error'); return; }
    try {
      if (editandoContato) {
        await api.patch(`/whatsapp/contatos/${editandoContato.id}`, contatoForm);
      } else {
        await api.post('/whatsapp/contatos', contatoForm);
      }
      await carregarContatos();
      setModalNovoContato(false);
      setContatoForm({ telefone: '', nome: '', email: '', empresa: '', observacao: '' });
      setEditandoContato(null);
      toast('Contato salvo!', 'success');
    } catch { toast('Erro ao salvar contato', 'error'); }
  };
  const excluirContato = async (id) => {
    if (!window.confirm('Excluir contato?')) return;
    try {
      await api.delete(`/whatsapp/contatos/${id}`);
      await carregarContatos();
      toast('Contato excluído', 'success');
    } catch { toast('Erro ao excluir', 'error'); }
  };
  const usarContatoParaIniciar = (contato) => {
    setIniciarForm(f => ({ ...f, telefone: contato.telefone, nome: contato.nome }));
    setModalContatos(false);
    setModalIniciar(true);
  };

  // ─── Gravação de Áudio ───────────────────────────────────────────────────────
  const iniciarGravacao = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioChunksRef.current = [];
      const mimeType =
        MediaRecorder.isTypeSupported('audio/mp4') ? 'audio/mp4' :
        MediaRecorder.isTypeSupported('audio/ogg;codecs=opus') ? 'audio/ogg;codecs=opus' :
        MediaRecorder.isTypeSupported('audio/webm;codecs=opus') ? 'audio/webm;codecs=opus' :
        MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : '';
      const options = mimeType ? { mimeType } : {};
      const mr = new MediaRecorder(stream, options);
      mr.ondataavailable = e => { if (e.data.size > 0) audioChunksRef.current.push(e.data); };
      mr.onstop = () => {
        const blob = new Blob(audioChunksRef.current, { type: mr.mimeType || 'audio/mp4' });
        setAudioBlob(blob);
        setAudioURL(URL.createObjectURL(blob));
        stream.getTracks().forEach(t => t.stop());
      };
      mr.start(250);
      mediaRecorderRef.current = mr;
      setGravando(true);
      setTempoGravacao(0);
      timerGravacaoRef.current = setInterval(() => setTempoGravacao(t => t + 1), 1000);
    } catch (err) {
      console.error('[Áudio]', err);
      toast('Sem permissão para microfone', 'error');
    }
  };

  const pararGravacao = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop();
    }
    clearInterval(timerGravacaoRef.current);
    setGravando(false);
  };

  const cancelarAudio = () => {
    if (mediaRecorderRef.current && gravando) {
      mediaRecorderRef.current.stop();
      clearInterval(timerGravacaoRef.current);
      setGravando(false);
    }
    setAudioBlob(null);
    setAudioURL(null);
    setTempoGravacao(0);
  };

  const enviarAudio = async () => {
    if (!audioBlob || !conversaSel) return;
    setEnviando(true);
    try {
      await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = async () => {
          try {
            const base64 = reader.result.split(',')[1];
            await api.post(`/whatsapp/conversas/${conversaSel.id}/audio`, {
              audio_base64: base64,
              duracao: tempoGravacao,
              mime_type: audioBlob.type,
            });
            setAudioBlob(null);
            setAudioURL(null);
            setTempoGravacao(0);
            await carregarMensagens(conversaSel.id);
            await carregarConversas();
            toast('Áudio enviado!', 'success');
            resolve();
          } catch (err) { reject(err); }
        };
        reader.onerror = reject;
        reader.readAsDataURL(audioBlob);
      });
    } catch { toast('Erro ao enviar áudio', 'error'); }
    setEnviando(false);
  };

  // ─── Enviar imagem/arquivo via paste ou botão ────────────────────────────────
  const [pastePreview, setPastePreview] = useState(null); // { file, url, tipo }

  const enviarArquivoPaste = async (arquivo) => {
    if (!conversaSel || !arquivo) return;
    setEnviando(true);
    try {
      await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = async () => {
          try {
            const base64 = reader.result; // inclui o header data:...;base64,...
            const isImagem = arquivo.type.startsWith('image/');
            const endpoint = isImagem ? 'imagem' : 'arquivo';
            await api.post(`/whatsapp/conversas/${conversaSel.id}/${endpoint}`, {
              arquivo_base64: base64,
              mime_type: arquivo.type,
              nome_arquivo: arquivo.name || (isImagem ? 'imagem.png' : 'arquivo'),
            });
            setPastePreview(null);
            await carregarMensagens(conversaSel.id);
            await carregarConversas();
            toast(isImagem ? 'Imagem enviada!' : 'Arquivo enviado!', 'success');
            resolve();
          } catch (err) { reject(err); }
        };
        reader.onerror = reject;
        reader.readAsDataURL(arquivo);
      });
    } catch { toast('Erro ao enviar arquivo', 'error'); }
    setEnviando(false);
  };

  const handlePaste = (e) => {
    if (!conversaSel) return;
    const items = Array.from(e.clipboardData?.items || []);
    const fileItem = items.find(i => i.kind === 'file');
    if (!fileItem) return;
    e.preventDefault();
    const arquivo = fileItem.getAsFile();
    if (!arquivo) return;
    const url = URL.createObjectURL(arquivo);
    const tipo = arquivo.type.startsWith('image/') ? 'imagem' : 'arquivo';
    setPastePreview({ file: arquivo, url, tipo, nome: arquivo.name });
  };

  // ─── Filtros ─────────────────────────────────────────────────────────────────
  const minhasFilas = filas.filter(f =>
    f.tecnicos_ids && f.tecnicos_ids.includes(usuario?.id)
  ).map(f => f.chave);

  const conversasFiltradas = conversas.filter(c => {
    const matchBusca = !busca ||
      (c.nome_contato || '').toLowerCase().includes(busca.toLowerCase()) ||
      (c.telefone || '').includes(busca);
    if (aba === 'fila') return matchBusca && c.status === 'aguardando' && (minhasFilas.length === 0 || minhasFilas.includes(c.fila));
    if (aba === 'meus') return matchBusca && c.status === 'em_atendimento' && c.atendente_id === usuario?.id;
    return false;
  });

  const contatosFiltrados = contatos.filter(c =>
    !buscaContato || c.nome.toLowerCase().includes(buscaContato.toLowerCase()) || c.telefone.includes(buscaContato)
  );

  const subcategoriasFiltradas = ticketForm.categoria_id
    ? (categoriasTicket.find(c => String(c.id) === String(ticketForm.categoria_id))?.subcategorias || [])
    : [];

  // ─── Renderização de mídia ───────────────────────────────────────────────────
  const renderConteudoMensagem = (m) => {
    const conteudo = m.conteudo || '';
    if (!conteudo.trim()) return null;

    if (conteudo.startsWith('[Áudio')) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: C.muted, fontSize: 13 }}>
          <span style={{ fontSize: 20 }}>🎵</span><span>{conteudo}</span>
        </div>
      );
    }

    const matchAudio   = conteudo.match(/^\[audio:(https?:\/\/.+)\]$/);
    const matchImagem  = conteudo.match(/^\[imagem:(https?:\/\/.+)\]$/);
    const matchGif     = conteudo.match(/^\[gif:(https?:\/\/.+)\]$/);
    const matchVideo   = conteudo.match(/^\[video:(https?:\/\/.+)\]$/);
    const matchDoc     = conteudo.match(/^\[documento:(https?:\/\/.+)\]$/);
    const matchSticker = conteudo.match(/^\[sticker:(https?:\/\/.+)\]$/);

    if (matchAudio)   return <audio controls src={matchAudio[1]}  style={{ maxWidth: 220, height: 36 }} />;
    if (matchImagem)  return <img src={matchImagem[1]}  alt="Imagem"   style={{ maxWidth: 200, borderRadius: 8, cursor: 'pointer' }} onClick={() => window.open(matchImagem[1], '_blank')} />;
    if (matchGif)     return <img src={matchGif[1]}     alt="GIF"      style={{ maxWidth: 200, borderRadius: 8 }} />;
    if (matchSticker) return <img src={matchSticker[1]} alt="Figurinha" style={{ maxWidth: 120, borderRadius: 8 }} />;
    if (matchVideo)   return <video controls src={matchVideo[1]}  style={{ maxWidth: 220, borderRadius: 8 }} />;
    if (matchDoc)     return <a href={matchDoc[1]} target="_blank" rel="noreferrer" style={{ color: C.navy, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>📄 Abrir documento</a>;

    if (conteudo === '[audio]')     return <span style={{ color: C.muted, fontSize: 13 }}>🎵 Áudio recebido</span>;
    if (conteudo === '[imagem]')    return <span style={{ color: C.muted, fontSize: 13 }}>🖼 Imagem recebida</span>;
    if (conteudo === '[gif]')       return <span style={{ color: C.muted, fontSize: 13 }}>🖼 GIF recebido</span>;
    if (conteudo === '[sticker]')   return <span style={{ color: C.muted, fontSize: 13 }}>🎭 Figurinha recebida</span>;
    if (conteudo === '[video]')     return <span style={{ color: C.muted, fontSize: 13 }}>🎬 Vídeo recebido</span>;
    if (conteudo === '[documento]') return <span style={{ color: C.muted, fontSize: 13 }}>📄 Documento recebido</span>;

    return <div style={{ fontSize: 14, color: C.text, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{conteudo}</div>;
  };

  // ─── Mobile: detecta tela pequena e controla visão sidebar/chat ─────────────
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 700);
  const [viewMobile, setViewMobile] = React.useState('sidebar'); // 'sidebar' | 'chat'

  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // Ao selecionar conversa no mobile, vai para view chat
  const selecionarConversaMobile = (conv) => {
    setConversaSel(conv);
    if (isMobile) setViewMobile('chat');
  };

  // ─── Render ──────────────────────────────────────────────────────────────────
  return (
    <div style={{ display: 'flex', height: isMobile ? 'calc(100svh - 112px)' : 'calc(100vh - 120px)', background: C.bg, borderRadius: isMobile ? 0 : 12, overflow: 'hidden', boxShadow: isMobile ? 'none' : '0 2px 12px rgba(0,0,0,0.08)', position: 'relative' }}>

      {/* ── Sidebar ── */}
      <div style={{ width: isMobile ? '100%' : 320, minWidth: isMobile ? 'unset' : 280, borderRight: `1px solid ${C.border}`, background: C.surface, display: isMobile && viewMobile === 'chat' ? 'none' : 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '16px 16px 8px', borderBottom: `1px solid ${C.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
            <span style={{ fontWeight: 700, fontSize: 16, color: C.navy }}>💬 Chat</span>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => { setModalContatos(true); carregarContatos(); }} title="Contatos"
                style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, padding: '5px 8px', cursor: 'pointer', fontSize: 16, color: C.muted }}>👥</button>
              <button onClick={() => setModalIniciar(true)} title="Nova conversa"
                style={{ background: C.orange, border: 'none', borderRadius: 8, padding: '5px 10px', cursor: 'pointer', color: '#fff', fontSize: 13, fontWeight: 600 }}>+ Novo</button>
              <button onClick={carregarConversas} title="Atualizar"
                style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, padding: '5px 8px', cursor: 'pointer', fontSize: 14, color: C.muted }}>🔄</button>
              {/* ── Toggle de som ── */}
              <button
                onClick={() => {
                  const novo = !somAtivo;
                  setSomAtivo(novo);
                  try { localStorage.setItem('som_alertas_ativo', String(novo)); } catch {}
                  // Sincroniza com o App.js imediatamente (sem depender de evento storage)
                  window.__somAlertasAtivo = novo;
                }}
                title={somAtivo ? 'Silenciar alertas sonoros' : 'Ativar alertas sonoros'}
                style={{
                  background: somAtivo ? '#fff7f4' : C.bg,
                  border: `1px solid ${somAtivo ? C.orange : C.border}`,
                  borderRadius: 8, padding: '5px 8px', cursor: 'pointer',
                  fontSize: 15, color: somAtivo ? C.orange : C.muted, transition: '.15s',
                }}
              >
                {somAtivo ? '🔔' : '🔕'}
              </button>
            </div>
          </div>
          <input placeholder="Buscar conversa..." value={busca} onChange={e => setBusca(e.target.value)}
            style={{ width: '100%', padding: '7px 12px', border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, boxSizing: 'border-box', outline: 'none' }} />
          <div style={{ display: 'flex', marginTop: 10, gap: 4 }}>
            {[['fila', 'Na fila'], ['meus', 'Meus']].map(([k, l]) => (
              <button key={k} onClick={() => setAba(k)}
                style={{ flex: 1, padding: '6px 0', border: 'none', borderBottom: aba === k ? `2px solid ${C.orange}` : '2px solid transparent',
                  background: 'transparent', cursor: 'pointer', fontWeight: aba === k ? 700 : 400,
                  color: aba === k ? C.orange : C.muted, fontSize: 13, borderRadius: '4px 4px 0 0' }}>
                {l}
                {aba === k && (
                  <span style={{ marginLeft: 6, background: C.orange, color: '#fff', borderRadius: 10, padding: '1px 6px', fontSize: 11 }}>
                    {conversasFiltradas.length}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto' }}>
          {conversasFiltradas.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: C.muted }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📬</div>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>Nenhum chat aguardando</div>
              {minhasFilas.length > 0 && <div style={{ fontSize: 12 }}>Suas filas: {minhasFilas.join(', ')}</div>}
            </div>
          ) : conversasFiltradas.map(conv => {
              const temNovaMensagem = !!novasMensagensMap[conv.id];
              const selecionada     = conversaSel?.id === conv.id;
              return (
                <div key={conv.id} onClick={() => selecionarConversa(conv)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', cursor: 'pointer',
                    borderBottom: `1px solid ${C.border}`,
                    background: selecionada ? '#fff7f4' : temNovaMensagem ? '#fffbf0' : 'transparent',
                    borderLeft: selecionada
                      ? `3px solid ${C.orange}`
                      : temNovaMensagem ? `3px solid #f59e0b` : '3px solid transparent',
                    transition: 'background 0.15s',
                    animation: temNovaMensagem && !selecionada ? 'piscar 1.2s ease-in-out infinite' : 'none',
                  }}>
                  <div style={{ position: 'relative' }}>
                    <Avatar nome={conv.nome_contato || conv.telefone} />
                    {/* Badge laranja de mensagem não lida */}
                    {temNovaMensagem && !selecionada && (
                      <span style={{
                        position: 'absolute', top: -3, right: -3,
                        width: 12, height: 12, borderRadius: '50%',
                        background: C.orange, border: '2px solid #fff',
                        display: 'block',
                      }} />
                    )}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      fontWeight: temNovaMensagem ? 700 : 600,
                      fontSize: 14, color: C.navy,
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    }}>
                      {conv.nome_contato || formatTelefone(conv.telefone)}
                    </div>
                    <div style={{
                      fontSize: 12,
                      color: temNovaMensagem ? '#92400e' : C.muted,
                      fontWeight: temNovaMensagem ? 600 : 400,
                      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    }}>
                      {temNovaMensagem && !selecionada ? '💬 Nova mensagem' : (conv.ultima_mensagem || '—')}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
                    <span style={{ fontSize: 11, color: temNovaMensagem ? '#92400e' : C.muted, fontWeight: temNovaMensagem ? 700 : 400 }}>
                      {formatHora(conv.ultima_mensagem_em)}
                    </span>
                    <span style={{ fontSize: 10, background: '#e8f4e8', color: '#2d6a2d', borderRadius: 6, padding: '1px 6px', fontWeight: 600 }}>
                      {conv.fila || 'suporte'}
                    </span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {/* ── Área de chat ── */}
      {conversaSel ? (
        <div style={{ flex: 1, display: isMobile && viewMobile === 'sidebar' ? 'none' : 'flex', flexDirection: 'column', background: '#ece5dd', minWidth: 0, width: isMobile ? '100%' : 'auto' }}>
          <div style={{ background: C.navy, padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
            {isMobile && (
              <button onClick={() => setViewMobile('sidebar')}
                style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, color: '#fff', width: 34, height: 34, cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                ←
              </button>
            )}
            <Avatar nome={conversaSel.nome_contato} size={40} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, color: '#fff', fontSize: 15 }}>{conversaSel.nome_contato || formatTelefone(conversaSel.telefone)}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>
                📱 {formatTelefone(conversaSel.telefone)} · Fila: {conversaSel.fila || 'suporte'}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
              {conversaSel.status === 'aguardando' && (
                <BtnAcao label="✋ Assumir" color={C.success} onClick={() => assumirConversa(conversaSel)} />
              )}
              {conversaSel.status === 'em_atendimento' && conversaSel.atendente_id === usuario?.id && (<>
                <BtnAcao label="↔" color="#7c3aed" onClick={() => { setTransferirTipo('fila'); setTransferirFila(''); setTransferirTecnico(''); setModalTransferir(true); }} />
                <BtnAcao label="🎫" color="#0369a1" onClick={abrirModalTicket} />
                <BtnAcao label="✓" color={C.orange} onClick={encerrarConversa} />
              </>)}
            </div>
          </div>

          <div
            ref={mensagensContainerRef}
            onScroll={() => {
              const el = mensagensContainerRef.current;
              if (!el) return;
              // Considera "no fim" se estiver a menos de 80px do final
              usuarioNoFimRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
            }}
            style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '12px 10px' : '20px 60px', display: 'flex', flexDirection: 'column', gap: 6 }}>
            {mensagens.map((m, i) => {
              const isAtendente = m.origem === 'atendente';
              const isBot = m.origem === 'bot';
              const conteudo = m.conteudo || '';
              if (!conteudo.trim()) return null;
              const conteudoRendered = renderConteudoMensagem(m);
              if (conteudoRendered === null) return null;
              return (
                <div key={m.id || i} style={{ display: 'flex', justifyContent: isAtendente ? 'flex-end' : 'flex-start' }}>
                  {isBot ? (
                    <div style={{ background: '#fff9c4', border: '1px solid #f0d060', borderRadius: 10, padding: '6px 12px', maxWidth: '70%', fontSize: 13, color: '#7a6000' }}>
                      <span style={{ fontSize: 11, fontWeight: 700 }}>🤖 Bot</span>
                      <div>{conteudo}</div>
                      <div style={{ fontSize: 10, color: '#aaa', textAlign: 'right', marginTop: 2 }}>{formatHora(m.criado_em)}</div>
                    </div>
                  ) : (
                    <div style={{ background: isAtendente ? '#dcf8c6' : '#fff',
                      borderRadius: isAtendente ? '12px 12px 0 12px' : '12px 12px 12px 0',
                      padding: '8px 14px', maxWidth: '70%', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
                      {isAtendente && (
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#128c7e', marginBottom: 2 }}>
                          {m.usuario_nome || 'Atendente'}
                        </div>
                      )}
                      {/* Mensagem citada — quando o cliente responde uma mensagem específica */}
                      {m.mensagem_citada && (
                        <div style={{ background: isAtendente ? 'rgba(0,0,0,0.07)' : '#f0f0f0', borderLeft: '3px solid #25D366', borderRadius: 6, padding: '4px 8px', marginBottom: 6, fontSize: 11, color: '#555', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          ↩ {m.mensagem_citada}
                        </div>
                      )}
                      {conteudoRendered}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginTop: 4 }}>
                        <button
                          onClick={() => {
                            setMensagemRespondendo(m);
                            setTimeout(() => textareaRef.current?.focus(), 50);
                          }}
                          style={{
                            border: 'none', background: 'transparent',
                            color: C.muted, fontSize: 11, cursor: 'pointer', padding: 0,
                          }}
                        >
                          ↩ Responder
                        </button>
                        <div style={{ fontSize: 10, color: '#999', textAlign: 'right' }}>
                          {formatHora(m.criado_em)}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div ref={messagesEndRef} />
          </div>

          {(conversaSel.status === 'em_atendimento' && conversaSel.atendente_id === usuario?.id) ? (
            <div style={{ background: '#f0f0f0', borderTop: `1px solid ${C.border}`, padding: '10px 16px' }}>
              {audioURL && !gravando && (
                <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10, background: '#fff', borderRadius: 10, padding: '8px 12px' }}>
                  <audio src={audioURL} controls style={{ flex: 1, height: 36 }} />
                  <button onClick={enviarAudio} disabled={enviando}
                    style={{ background: C.success, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
                    {enviando ? '...' : '▶ Enviar'}
                  </button>
                  <button onClick={cancelarAudio}
                    style={{ background: C.error, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 13 }}>✕</button>
                </div>
              )}
              {gravando && (
                <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 12, background: '#fff0f0', borderRadius: 10, padding: '8px 14px' }}>
                  <span style={{ animation: 'pulse 1s infinite', fontSize: 18, color: C.error }}>🔴</span>
                  <span style={{ fontWeight: 600, color: C.error, fontSize: 14 }}>Gravando... {tempoGravacao}s</span>
                  <button onClick={pararGravacao}
                    style={{ marginLeft: 'auto', background: C.navy, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontWeight: 600 }}>⏹ Parar</button>
                  <button onClick={cancelarAudio}
                    style={{ background: 'transparent', color: C.muted, border: 'none', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
                </div>
              )}
              {!gravando && !audioURL && (
                <>
                  {mensagemRespondendo && (
                    <div style={{
                      background: '#fff', borderLeft: '4px solid #25D366',
                      borderRadius: 8, padding: '6px 10px', marginBottom: 8,
                      fontSize: 12, color: C.muted,
                      display: 'flex', justifyContent: 'space-between', gap: 8,
                    }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        ↩ Respondendo: {mensagemRespondendo.conteudo}
                      </div>
                      <button
                        onClick={() => setMensagemRespondendo(null)}
                        style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: C.error, flexShrink: 0 }}
                      >✕</button>
                    </div>
                  )}
                  {/* Preview de arquivo/imagem colado */}
                  {pastePreview && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: '#f0f4ff', borderRadius: 10, marginBottom: 6, border: '1px solid #c7d7ff' }}>
                      {pastePreview.tipo === 'imagem'
                        ? <img src={pastePreview.url} alt="preview" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 6, flexShrink: 0 }} />
                        : <span style={{ fontSize: 28, flexShrink: 0 }}>📄</span>
                      }
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: '#1A2233', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {pastePreview.nome || (pastePreview.tipo === 'imagem' ? 'Imagem' : 'Arquivo')}
                        </div>
                        <div style={{ fontSize: 11, color: '#6b7a8d', marginTop: 2 }}>Clique em enviar para confirmar</div>
                      </div>
                      <button onClick={() => setPastePreview(null)}
                        style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 18, padding: 4, flexShrink: 0 }}>✕</button>
                      <button onClick={() => enviarArquivoPaste(pastePreview.file)} disabled={enviando}
                        style={{ background: '#D85A30', border: 'none', borderRadius: 8, color: '#fff', padding: '6px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 700, flexShrink: 0 }}>
                        {enviando ? '…' : '➤ Enviar'}
                      </button>
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
                    <textarea ref={textareaRef} value={texto} onChange={e => setTexto(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); enviarMensagem(); } }}
                      onPaste={handlePaste}
                      placeholder="Digite uma mensagem ou cole uma imagem/arquivo..." rows={1}
                      style={{ flex: 1, padding: '10px 14px', border: 'none', borderRadius: 24, fontSize: 14, outline: 'none',
                        resize: 'none', maxHeight: 100, background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        fontFamily: 'inherit', overflowY: 'auto' }} />
                    <button onClick={iniciarGravacao} title="Gravar áudio"
                      style={{ background: C.muted, border: 'none', borderRadius: '50%', width: 42, height: 42, cursor: 'pointer', fontSize: 18, color: '#fff', flexShrink: 0 }}>🎤</button>
                    <button onClick={enviarMensagem} disabled={!texto.trim() || enviando}
                      style={{ background: texto.trim() ? C.orange : C.border, border: 'none', borderRadius: '50%', width: 42, height: 42,
                        cursor: texto.trim() ? 'pointer' : 'default', fontSize: 18, color: '#fff', flexShrink: 0, transition: 'background 0.2s' }}>
                      {enviando ? '…' : '➤'}
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : conversaSel.status === 'aguardando' ? (
            <div style={{ background: '#fff', padding: 16, textAlign: 'center', borderTop: `1px solid ${C.border}` }}>
              <button onClick={() => assumirConversa(conversaSel)}
                style={{ background: C.success, color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
                ✋ Assumir atendimento
              </button>
            </div>
          ) : (
            <div style={{ background: '#f5f5f5', padding: '12px 20px', textAlign: 'center', color: C.muted, fontSize: 13, borderTop: `1px solid ${C.border}` }}>
              Atendimento encerrado
            </div>
          )}
        </div>
      ) : !isMobile ? (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#ece5dd', color: C.muted, gap: 16 }}>
          <div style={{ fontSize: 64 }}>💬</div>
          <div style={{ fontWeight: 700, fontSize: 18, color: C.navy }}>Selecione uma conversa</div>
          <div style={{ fontSize: 14 }}>Ou inicie uma nova clicando em <strong>+ Novo</strong></div>
          <button onClick={() => setModalIniciar(true)}
            style={{ marginTop: 8, background: C.orange, color: '#fff', border: 'none', borderRadius: 10, padding: '10px 24px', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
            + Nova Conversa
          </button>
        </div>
      ) : null}

      {/* ═══════════ MODAIS ═══════════ */}

      {modalIniciar && (
        <Modal titulo="Nova Conversa" onClose={() => setModalIniciar(false)}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', gap: 8 }}>
              <div style={{ flex: 1 }}>
                <Label>Telefone *</Label>
                <input value={iniciarForm.telefone} onChange={e => setIniciarForm(f => ({ ...f, telefone: e.target.value }))} placeholder="5511999999999" style={inputStyle} />
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <button onClick={() => { carregarContatos(); setModalContatos(true); setModalIniciar(false); }}
                  style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, padding: '8px 10px', cursor: 'pointer', fontSize: 16 }}>👥</button>
              </div>
            </div>
            <div><Label>Nome do contato</Label>
              <input value={iniciarForm.nome} onChange={e => setIniciarForm(f => ({ ...f, nome: e.target.value }))} placeholder="Nome (opcional)" style={inputStyle} /></div>
            <div><Label>Fila</Label>
              <select value={iniciarForm.fila} onChange={e => setIniciarForm(f => ({ ...f, fila: e.target.value }))} style={inputStyle}>
                {filas.map(f => <option key={f.chave} value={f.chave}>{f.nome}</option>)}
              </select></div>
            <div><Label>Mensagem *</Label>
              <textarea value={iniciarForm.mensagem} onChange={e => setIniciarForm(f => ({ ...f, mensagem: e.target.value }))}
                placeholder="Olá! Como posso ajudar?" rows={3} style={{ ...inputStyle, resize: 'vertical' }} /></div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
              <BtnSecundario label="Cancelar" onClick={() => setModalIniciar(false)} />
              <BtnPrimario label="📤 Enviar" onClick={confirmarIniciarConversa} />
            </div>
          </div>
        </Modal>
      )}

      {modalContatos && (
        <Modal titulo="👥 Contatos" onClose={() => setModalContatos(false)} largura={520}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <input value={buscaContato} onChange={e => setBuscaContato(e.target.value)} placeholder="Buscar contato..." style={{ ...inputStyle, flex: 1 }} />
            <button onClick={() => { setContatoForm({ telefone: '', nome: '', email: '', empresa: '', observacao: '' }); setEditandoContato(null); setModalNovoContato(true); carregarClientesOrcamento(); }}
              style={{ background: C.orange, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>+ Novo</button>
          </div>
          <div style={{ maxHeight: 360, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
            {contatosFiltrados.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 30, color: C.muted }}>Nenhum contato cadastrado</div>
            ) : contatosFiltrados.map(c => (
              <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, border: `1px solid ${C.border}`, background: C.bg }}>
                <Avatar nome={c.nome} size={34} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 14, color: C.navy }}>{c.nome}</div>
                  <div style={{ fontSize: 12, color: C.muted }}>{formatTelefone(c.telefone)}</div>
                </div>
                <button onClick={() => usarContatoParaIniciar(c)} style={{ background: C.success, color: '#fff', border: 'none', borderRadius: 6, padding: '5px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>💬</button>
                <button onClick={() => { setContatoForm({ ...c }); setEditandoContato(c); setModalNovoContato(true); carregarClientesOrcamento(); }} style={{ background: C.bg, color: C.navy, border: `1px solid ${C.border}`, borderRadius: 6, padding: '5px 10px', cursor: 'pointer', fontSize: 12 }}>✏️</button>
                <button onClick={() => excluirContato(c.id)} style={{ background: '#fff0f0', color: C.error, border: `1px solid #fca5a5`, borderRadius: 6, padding: '5px 10px', cursor: 'pointer', fontSize: 12 }}>🗑</button>
              </div>
            ))}
          </div>
        </Modal>
      )}

      {modalNovoContato && (
        <Modal titulo={editandoContato ? 'Editar Contato' : 'Novo Contato'} onClose={() => setModalNovoContato(false)}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div><Label>Telefone *</Label>
              <input value={contatoForm.telefone} onChange={e => setContatoForm(f => ({ ...f, telefone: e.target.value }))} placeholder="5511999999999" style={inputStyle} disabled={!!editandoContato} /></div>
            <div><Label>Nome *</Label>
              <input value={contatoForm.nome} onChange={e => setContatoForm(f => ({ ...f, nome: e.target.value }))} placeholder="Nome completo" style={inputStyle} /></div>
            <div><Label>Empresa</Label>
              <EmpresaSelect
                value={contatoForm.empresa || ''}
                onChange={v => setContatoForm(f => ({ ...f, empresa: v }))}
                clientes={clientesOrcamento}
                style={inputStyle}
              /></div>
            <div><Label>E-mail</Label>
              <input value={contatoForm.email} onChange={e => setContatoForm(f => ({ ...f, email: e.target.value }))} placeholder="email@exemplo.com" style={inputStyle} /></div>
            <div><Label>Observação</Label>
              <textarea value={contatoForm.observacao} onChange={e => setContatoForm(f => ({ ...f, observacao: e.target.value }))} placeholder="Anotações..." rows={2} style={{ ...inputStyle, resize: 'vertical' }} /></div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <BtnSecundario label="Cancelar" onClick={() => setModalNovoContato(false)} />
              <BtnPrimario label="💾 Salvar" onClick={salvarContato} />
            </div>
          </div>
        </Modal>
      )}

      {modalTransferir && (
        <Modal titulo="↔ Transferir Atendimento" onClose={() => setModalTransferir(false)}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', border: `1px solid ${C.border}`, borderRadius: 8, overflow: 'hidden' }}>
              {[['fila', '📂 Para fila'], ['tecnico', '👤 Para técnico']].map(([k, l]) => (
                <button key={k} onClick={() => setTransferirTipo(k)}
                  style={{ flex: 1, padding: '8px 0', border: 'none', background: transferirTipo === k ? C.navy : '#fff',
                    color: transferirTipo === k ? '#fff' : C.muted, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>{l}</button>
              ))}
            </div>
            {transferirTipo === 'fila' ? (
              <div>
                <Label>Fila de destino</Label>
                <select value={transferirFila} onChange={e => setTransferirFila(e.target.value)} style={inputStyle}>
                  <option value="">Selecione uma fila...</option>
                  {filas.map(f => <option key={f.chave} value={f.chave}>{f.nome}</option>)}
                </select>
                <p style={{ fontSize: 12, color: C.muted, margin: '6px 0 0' }}>O chat voltará para a fila sem atendente.</p>
              </div>
            ) : (
              <div>
                <Label>Técnico de destino</Label>
                <select value={transferirTecnico} onChange={e => setTransferirTecnico(e.target.value)} style={inputStyle}>
                  <option value="">Selecione um técnico...</option>
                  {usuarios.filter(u => String(u.id) !== String(usuario?.id)).map(u => (
                    <option key={u.id} value={u.id}>{u.nome}</option>
                  ))}
                </select>
                {usuarios.filter(u => String(u.id) !== String(usuario?.id)).length === 0 && (
                  <p style={{ fontSize: 12, color: C.error, margin: '6px 0 0' }}>
                    Nenhum outro usuário ativo encontrado. Verifique se há outros técnicos cadastrados.
                  </p>
                )}
              </div>
            )}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <BtnSecundario label="Cancelar" onClick={() => setModalTransferir(false)} />
              <BtnPrimario label="↔ Transferir" onClick={confirmarTransferir} color="#7c3aed" />
            </div>
          </div>
        </Modal>
      )}

      {/* Modal Ticket — 2 colunas */}
      {modalTicket && (
        <Modal titulo="🎫 Criar Ticket e Encerrar Chat" onClose={() => setModalTicket(false)} largura={680}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            <div style={{ background: '#fff7e6', border: '1px solid #f59e0b', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#92400e', marginBottom: 16 }}>
              ⚠️ O histórico do chat será copiado para o ticket e o atendimento será encerrado.
            </div>
            <div style={{ display: 'flex', gap: 20, flexDirection: window.innerWidth < 700 ? 'column' : 'row' }}>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: C.navy, borderBottom: `1px solid ${C.border}`, paddingBottom: 6 }}>📋 Dados do Atendimento</div>

                {/* Campo Cliente com busca — obrigatório */}
                <div style={{ position: 'relative' }}>
                  <Label>Cliente *</Label>
                  <input
                    value={ticketClienteBusca}
                    onChange={e => {
                      const v = e.target.value;
                      setTicketClienteBusca(v);
                      setTicketClienteId('');
                      if (v.length >= 1) {
                        const q = v.toLowerCase();
                        const sug = clientesOrcamento.filter(c =>
                          (c.nome || '').toLowerCase().includes(q) ||
                          (c.cliente_apelido || '').toLowerCase().includes(q)
                        ).slice(0, 8);
                        setTicketClienteSugestoes(sug);
                        setTicketClienteAberto(true);
                      } else {
                        setTicketClienteSugestoes([]);
                        setTicketClienteAberto(false);
                      }
                    }}
                    onFocus={() => {
                      if (ticketClienteBusca.length >= 1 && ticketClienteSugestoes.length > 0)
                        setTicketClienteAberto(true);
                    }}
                    onBlur={() => setTimeout(() => setTicketClienteAberto(false), 200)}
                    placeholder="Digite para buscar cliente..."
                    style={{
                      ...inputStyle,
                      borderColor: !ticketClienteId ? '#f59e0b' : C.border,
                      background: ticketClienteId ? '#f0fff4' : '#fff',
                    }}
                  />
                  {ticketClienteId && (
                    <button
                      onClick={() => { setTicketClienteId(''); setTicketClienteBusca(''); setTicketClienteSugestoes([]); }}
                      style={{ position: 'absolute', right: 8, top: 30, background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: C.muted }}
                      title="Limpar cliente"
                    >✕</button>
                  )}
                  {ticketClienteAberto && ticketClienteSugestoes.length > 0 && (
                    <div style={{
                      position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50,
                      background: '#fff', border: `1px solid ${C.border}`, borderRadius: 8,
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: 200, overflowY: 'auto',
                    }}>
                      {ticketClienteSugestoes.map(c => (
                        <div
                          key={c.id}
                          onMouseDown={() => {
                            setTicketClienteId(String(c.id));
                            setTicketClienteBusca(c.cliente_apelido ? `${c.cliente_apelido} (${c.nome})` : c.nome);
                            setTicketClienteSugestoes([]);
                            setTicketClienteAberto(false);
                            // Solicitante NUNCA muda — mantém o nome de quem chamou no chat
                            // Telefone e email só preenchem se ainda estiverem vazios
                            setTicketForm(f => ({
                              ...f,
                              telefone_cliente: f.telefone_cliente || c.telefone || '',
                              email_cliente: f.email_cliente || c.email || '',
                            }));
                          }}
                          style={{
                            padding: '9px 14px', cursor: 'pointer', fontSize: 13,
                            borderBottom: `1px solid ${C.border}`,
                            color: C.navy, transition: 'background 0.1s',
                          }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f5f7fa'}
                          onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                        >
                          <strong>{c.cliente_apelido || c.nome}</strong>
                          {c.cliente_apelido && <span style={{ color: C.muted, marginLeft: 6, fontSize: 12 }}>{c.nome}</span>}
                          {c.telefone && <span style={{ color: C.muted, marginLeft: 8, fontSize: 11 }}>📱 {c.telefone}</span>}
                        </div>
                      ))}
                    </div>
                  )}
                  {ticketClienteSugestoes.length === 0 && ticketClienteAberto && ticketClienteBusca.length >= 1 && (
                    <div style={{
                      position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50,
                      background: '#fff', border: `1px solid ${C.border}`, borderRadius: 8,
                      padding: '10px 14px', fontSize: 13, color: C.muted,
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                    }}>
                      Nenhum cliente encontrado
                    </div>
                  )}
                </div>

                <div><Label>Título *</Label>
                  <input value={ticketForm.titulo} onChange={e => setTicketForm(f => ({ ...f, titulo: e.target.value }))} placeholder="Descreva o assunto do atendimento..." style={inputStyle} /></div>
                <div><Label>Solicitante *</Label>
                  <input value={ticketForm.solicitante} onChange={e => setTicketForm(f => ({ ...f, solicitante: e.target.value }))} placeholder="Nome do cliente" style={inputStyle} /></div>
                <div><Label>Telefone *</Label>
                  <input value={ticketForm.telefone_cliente} onChange={e => setTicketForm(f => ({ ...f, telefone_cliente: e.target.value }))} style={inputStyle} /></div>
                <div><Label>E-mail</Label>
                  <input value={ticketForm.email_cliente} onChange={e => setTicketForm(f => ({ ...f, email_cliente: e.target.value }))} placeholder="email@exemplo.com" style={inputStyle} /></div>
                <div><Label>Descrição *</Label>
                  <textarea value={ticketForm.descricao} onChange={e => setTicketForm(f => ({ ...f, descricao: e.target.value }))}
                    placeholder="Descreva o problema..." rows={3} style={{ ...inputStyle, resize: 'vertical' }} /></div>
                <div><Label>Comentário / Resolução</Label>
                  <textarea value={ticketForm.comentario} onChange={e => setTicketForm(f => ({ ...f, comentario: e.target.value }))}
                    placeholder="Descreva o que foi feito..." rows={3} style={{ ...inputStyle, resize: 'vertical' }} /></div>
              </div>
              <div style={{ width: window.innerWidth < 700 ? '100%' : 240, display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: C.navy, borderBottom: `1px solid ${C.border}`, paddingBottom: 6 }}>⚙️ Classificação</div>
                <div><Label>Tipo de Ticket *</Label>
                  <select value={ticketForm.tipo_id} onChange={e => setTicketForm(f => ({ ...f, tipo_id: e.target.value }))} style={inputStyle}>
                    <option value="">Selecione...</option>
                    {tiposTicket.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                  </select></div>
                <div><Label>Categoria *</Label>
                  <select value={ticketForm.categoria_id} onChange={e => setTicketForm(f => ({ ...f, categoria_id: e.target.value, subcategoria_id: '' }))} style={inputStyle}>
                    <option value="">Selecione...</option>
                    {categoriasTicket.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                  </select></div>
                {subcategoriasFiltradas.length > 0 && (
                  <div><Label>Subcategoria</Label>
                    <select value={ticketForm.subcategoria_id} onChange={e => setTicketForm(f => ({ ...f, subcategoria_id: e.target.value }))} style={inputStyle}>
                      <option value="">Selecione...</option>
                      {subcategoriasFiltradas.map(s => <option key={s.id} value={s.id}>{s.nome}</option>)}
                    </select></div>
                )}
                <div><Label>Mesa de Trabalho *</Label>
                  <select value={ticketForm.mesa_id} onChange={e => setTicketForm(f => ({ ...f, mesa_id: e.target.value, operador_id: '' }))} style={inputStyle}>
                    <option value="">Selecione...</option>
                    {mesasTicket.map(m => <option key={m.id} value={m.id}>{m.nome}</option>)}
                  </select></div>
                <div><Label>Operador</Label>
                  <select value={ticketForm.operador_id} onChange={e => setTicketForm(f => ({ ...f, operador_id: e.target.value }))} style={inputStyle}>
                    <option value="">Selecione...</option>
                    {(ticketForm.mesa_id ? operadoresMesa : usuarios).map(u => (
                      <option key={u.id} value={u.id}>{u.nome}</option>
                    ))}
                  </select></div>
                <div><Label>Tipo de Atendimento</Label>
                  <div style={{ display: 'flex', border: `1px solid ${C.border}`, borderRadius: 8, overflow: 'hidden' }}>
                    {[['interno', 'Interno'], ['externo', 'Externo']].map(([v, l]) => (
                      <button key={v} onClick={() => setTicketForm(f => ({ ...f, tipo_atendimento: v }))}
                        style={{ flex: 1, padding: '8px 0', border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                          background: ticketForm.tipo_atendimento === v ? C.navy : '#fff',
                          color: ticketForm.tipo_atendimento === v ? '#fff' : C.muted }}>{l}</button>
                    ))}
                  </div></div>
                <div>
                  <Label>Tempo de atendimento (HH:MM)</Label>
                  <input value={ticketForm.tempo_hhmm} onChange={e => setTicketForm(f => ({ ...f, tempo_hhmm: e.target.value }))}
                    placeholder="00:00" style={inputStyle} maxLength={5} />
                  <div style={{ fontSize: 11, color: C.muted, marginTop: 3 }}>Calculado a partir do início do chat</div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20, paddingTop: 16, borderTop: `1px solid ${C.border}` }}>
              <BtnSecundario label="Cancelar" onClick={() => setModalTicket(false)} />
              <BtnPrimario label="🎫 Criar Ticket e Encerrar" onClick={confirmarCriarTicket} color="#0369a1" />
            </div>
          </div>
        </Modal>
      )}

      {/* Modal Salvar Contato antes de encerrar */}
      {modalSalvarContato && (
        <Modal
          titulo={modalSalvarContato === 'ticket' ? '🎫 Antes de criar o ticket...' : '✓ Antes de encerrar...'}
          onClose={() => setModalSalvarContato(false)}
          largura={460}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#0369a1' }}>
              👤 Este contato ainda não está na agenda. Deseja salvar para facilitar futuros atendimentos?
            </div>

            <div>
              <Label>Nome *</Label>
              <input value={salvarContatoForm.nome}
                onChange={e => setSalvarContatoForm(f => ({ ...f, nome: e.target.value }))}
                placeholder="Nome completo" style={inputStyle} />
            </div>
            <div>
              <Label>Telefone *</Label>
              <input value={salvarContatoForm.telefone}
                onChange={e => setSalvarContatoForm(f => ({ ...f, telefone: e.target.value }))}
                placeholder="5511999999999" style={inputStyle} />
            </div>
            <div>
              <Label>Empresa</Label>
              <EmpresaSelect
                value={salvarContatoForm.empresa || ''}
                onChange={v => setSalvarContatoForm(f => ({ ...f, empresa: v }))}
                clientes={clientesOrcamento}
                style={inputStyle}
              />
            </div>
            <div>
              <Label>E-mail</Label>
              <input type="email" value={salvarContatoForm.email}
                onChange={e => setSalvarContatoForm(f => ({ ...f, email: e.target.value }))}
                placeholder="email@exemplo.com" style={inputStyle} />
            </div>
            <div>
              <Label>Observação</Label>
              <textarea value={salvarContatoForm.observacao}
                onChange={e => setSalvarContatoForm(f => ({ ...f, observacao: e.target.value }))}
                placeholder="Anotações sobre o cliente..." rows={2}
                style={{ ...inputStyle, resize: 'vertical' }} />
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', paddingTop: 4 }}>
              <BtnSecundario
                label={modalSalvarContato === 'ticket' ? '⏭ Criar sem salvar' : '⏭ Encerrar sem salvar'}
                onClick={() => {
                  if (modalSalvarContato === 'ticket') _executarCriarTicket(false);
                  else _executarEncerrar(false);
                }}
              />
              <BtnPrimario
                label={modalSalvarContato === 'ticket' ? '💾 Salvar e criar ticket' : '💾 Salvar e encerrar'}
                onClick={() => {
                  if (modalSalvarContato === 'ticket') _executarCriarTicket(true);
                  else _executarEncerrar(true);
                }}
                color={modalSalvarContato === 'ticket' ? '#0369a1' : C.orange}
              />
            </div>
          </div>
        </Modal>
      )}

      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }`}</style>
    </div>
  );
}

function Modal({ titulo, onClose, children, largura = 440 }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: window.innerWidth < 700 ? 'flex-end' : 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: window.innerWidth < 700 ? '14px 14px 0 0' : 14, width: window.innerWidth < 700 ? '100%' : largura, maxWidth: '100vw', maxHeight: window.innerWidth < 700 ? '92svh' : '90vh', overflowY: 'auto', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: `1px solid ${C.border}` }}>
          <span style={{ fontWeight: 700, fontSize: 15, color: C.navy }}>{titulo}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: C.muted, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: window.innerWidth < 700 ? '14px 12px' : 20 }}>{children}</div>
      </div>
    </div>
  );
}
function Label({ children }) {
  return <div style={{ fontSize: 12, fontWeight: 600, color: C.muted, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.4 }}>{children}</div>;
}
function BtnAcao({ label, color, onClick }) {
  return <button onClick={onClick} style={{ background: color, color: '#fff', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 12, whiteSpace: 'nowrap' }}>{label}</button>;
}
function BtnPrimario({ label, onClick, color }) {
  return <button onClick={onClick} style={{ background: color || C.orange, color: '#fff', border: 'none', borderRadius: 8, padding: '9px 20px', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>{label}</button>;
}
function BtnSecundario({ label, onClick }) {
  return <button onClick={onClick} style={{ background: C.bg, color: C.navy, border: `1px solid ${C.border}`, borderRadius: 8, padding: '9px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>{label}</button>;
}
const inputStyle = {
  width: '100%', padding: '9px 12px', border: `1px solid ${C.border}`,
  borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box',
  fontFamily: 'inherit', color: C.text, background: '#fff',
};
